export default __webpack_public_path__ + "static/media/banner.4ab3295d.png";